import { useEffect } from 'react';
import { match } from 'react-router-dom';

import Contact from './Contact';
import Footer from '../../../Schedule/Form/Footer';
import Header from './Header';
import Specialties from './Specialties';

import EmbeddedFooter from '../Common/EmbeddedFooter';

import { useSelector } from 'react-redux';
import * as store from '../../../../reducers/store';

import { Location } from '../Search';

interface Props {
  match: match;
  sendHeight: () => void;
  ipLocation?: Location;
}

const LandingPage: React.FC<Props> = ({ match, sendHeight, ipLocation }) => {
  const embedded = useSelector((store: store.All) => store.embedded);
  useEffect(() => {
    if (embedded) {
      sendHeight();
    }
  });

  return (
    <div className="overflow-hidden">
      <Header match={match} ipLocation={ipLocation} />
      <Specialties match={match} />
      <Contact />
      {embedded ? <EmbeddedFooter /> : <Footer />}
    </div>
  );
};
export default LandingPage;
